export default "__VITE_ASSET__497d20b2__"